import { useState } from 'react'
import { useSelector } from 'react-redux'
import Form from 'react-bootstrap/Form'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import SubjectTopicSelect from '../../../components/_questions/SubjectTopicSelect'
import trash_img from '../../../assets/images/trash.svg'
import add_img from '../../../assets/images/add.svg'

const COMPACT_PREVIEW_LIMIT = 6

export default function ModuleTopics({ topics, subjects, allTopics, isCustomizable, onChange, onSelectWholeSubject }) {
    const t = useSelector(selectTranslations)
    const [wholeSubject, setWholeSubject] = useState('')
    const [showAllSimple, setShowAllSimple] = useState(false)

    const handleSelectWholeSubject = (e) => {
        const subject_id = e.target.value
        if (!subject_id) return
        onSelectWholeSubject(subject_id)
        setWholeSubject('')
        setShowAllSimple(false)
    }

    const handleUpdateGroup = (groupIndex, changes) => {
        const _groups = structuredClone(topics || [])
        _groups[groupIndex] = { ..._groups[groupIndex], ...changes }
        onChange(_groups)
    }

    const handleAddGroup = () => {
        onChange([...(topics || []), { topic_ids: [], num_questions: isCustomizable ? 60 : 1 }])
    }

    const handleRemoveGroup = (groupIndex) => {
        const _groups = structuredClone(topics || [])
        _groups.splice(groupIndex, 1)
        onChange(_groups)
    }

    const getTopicName = (topic_id) => allTopics?.find(topic => topic.topic_id === topic_id)?.topic_name || topic_id

    // I gruppi con un solo argomento (tipicamente generati da "Compila da materia completa")
    // vengono mostrati in una lista compatta, per non dover scorrere un'intera card per argomento.
    const indexedGroups = (topics || []).map((group, index) => ({ group, index }))
    const simpleGroups = indexedGroups.filter(({ group }) => group.topic_ids?.length === 1)
    const complexGroups = indexedGroups.filter(({ group }) => group.topic_ids?.length !== 1)
    const visibleSimpleGroups = showAllSimple ? simpleGroups : simpleGroups.slice(0, COMPACT_PREVIEW_LIMIT)

    const totalTopicsCount = (topics || []).reduce((sum, g) => sum + (g.topic_ids?.length || 0), 0)
    const totalQuestionsCount = (topics || []).reduce((sum, g) => sum + (parseInt(g.num_questions) || 0), 0)

    return (
        <div className="module_topics">
            <Form.Group className="mb-3" controlId="module_topics_whole_subject">
                <Form.Label>{t.question_bank.select_whole_subject}</Form.Label>
                <Form.Select value={wholeSubject} onChange={handleSelectWholeSubject}>
                    <option value="">{t.question_bank.select_subject}</option>
                    {subjects?.map(s => (
                        <option key={s.subject_id} value={s.subject_id}>{s.subject_name}</option>
                    ))}
                </Form.Select>
                <Form.Text className="text-muted">{t.question_bank.select_whole_subject_hint}</Form.Text>
            </Form.Group>

            {topics?.length > 0 &&
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <strong>{t.question_bank.topics_added_title}</strong>
                    <span className="text-muted">
                        {t.question_bank.topics_added_summary
                            .replace('{count}', totalTopicsCount)
                            .replace('{total}', totalQuestionsCount)}
                    </span>
                </div>
            }

            {simpleGroups.length > 0 &&
                <div className="topics_compact_list mb-2">
                    {visibleSimpleGroups.map(({ group, index }) => (
                        <div key={index} className="module_question d-flex align-items-center justify-content-between">
                            <span>{getTopicName(group.topic_ids[0])}</span>
                            <div className="d-flex align-items-center">
                                <Form.Control
                                    type="number"
                                    min={1}
                                    style={{width: '80px'}}
                                    className="minw-0"
                                    value={group.num_questions || ''}
                                    onChange={(e) => handleUpdateGroup(index, { num_questions: e.target.value })}
                                />
                                <span className="ms-2 text-muted">{t.question_bank.num_questions_group_short}</span>
                                <img src={trash_img} className="ms-3 pointer" alt="" onClick={() => handleRemoveGroup(index)} />
                            </div>
                        </div>
                    ))}
                    {simpleGroups.length > COMPACT_PREVIEW_LIMIT &&
                        <button className="secondary mt-2" onClick={() => setShowAllSimple(!showAllSimple)}>
                            {showAllSimple ? t.question_bank.show_less_topics : t.question_bank.show_all_topics.replace('{count}', simpleGroups.length)}
                        </button>
                    }
                </div>
            }

            {complexGroups.map(({ group, index }) => (
                <div key={index} className="questions_module mt-2">
                    <div className="d-flex justify-content-between align-items-start">
                        <div className="flex-grow-1">
                            <SubjectTopicSelect
                                subjects={subjects}
                                topics={allTopics}
                                value={group.topic_ids}
                                onChange={(topic_ids) => handleUpdateGroup(index, { topic_ids })}
                            />
                        </div>
                        <img src={trash_img} className="ms-2 pointer" alt="" onClick={() => handleRemoveGroup(index)} />
                    </div>
                    <Form.Group className="mt-2" controlId={`group_num_questions_${index}`}>
                        <Form.Label>{t.question_bank.num_questions_group}</Form.Label>
                        <Form.Control
                            type="number"
                            min={1}
                            className="minw-0"
                            value={group.num_questions || ''}
                            onChange={(e) => handleUpdateGroup(index, { num_questions: e.target.value })}
                        />
                    </Form.Group>
                </div>
            ))}
            <button className="secondary mt-2" onClick={handleAddGroup}>
                <img src={add_img} alt="" />
                {t.question_bank.add_topic_group}
            </button>
        </div>
    )
}
